/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CsvError from './CsvError';

/**
* The UploadCustomerCsvResponse model module.
* @module model/UploadCustomerCsvResponse
* @version 2020-12-7
*/
export default class UploadCustomerCsvResponse {
    /**
    * Constructs a new <code>UploadCustomerCsvResponse</code>.
    * 顧客CSV一括登録レスポンス
    * @alias module:model/UploadCustomerCsvResponse
    * @class
    * @param result {module:model/UploadCustomerCsvResponse.ResultEnum} 
    */

    constructor(result) {
        
        
        this['result'] = result;
        
    }

    /**
    * Constructs a <code>UploadCustomerCsvResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/UploadCustomerCsvResponse} obj Optional instance to populate.
    * @return {module:model/UploadCustomerCsvResponse} The populated <code>UploadCustomerCsvResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UploadCustomerCsvResponse();
                        
            
            if (data.hasOwnProperty('errors')) {
                obj['errors'] = ApiClient.convertToType(data['errors'], [CsvError]);
            }
            if (data.hasOwnProperty('uploadResultNumber')) {
                obj['uploadResultNumber'] = ApiClient.convertToType(data['uploadResultNumber'], 'String');
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], 'String');
            }
        }
        return obj;
    }

    /**
    * 発生したエラー
    * @member {Array.<module:model/CsvError>} errors
    */
    'errors' = undefined;
    /**
    * @member {String} uploadResultNumber
    */
    'uploadResultNumber' = undefined;
    /**
    * @member {module:model/UploadCustomerCsvResponse.ResultEnum} result
    */
    'result' = undefined;



    /**
    * Allowed values for the <code>result</code> property.
    * @enum {String}
    * @readonly
    */
    static ResultEnum = {
        /**
         * value: "NG"
         * @const
         */
        "NG": "NG",
        /**
         * value: "OK"
         * @const
         */
        "OK": "OK"    };

}
